import React from 'react';
import { getTheme } from '../config/theme';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Get user's theme or default to dark
      const currentThemeName = localStorage.getItem('selectedTheme') || 'dark';
      const theme = getTheme(currentThemeName) || getTheme('dark');
      
      return (
        <div 
          className="min-h-screen flex items-center justify-center p-4" 
          style={{ backgroundColor: theme?.colors?.primary || '#1e293b' }}
        >
          <div 
            className="p-8 rounded-lg shadow-lg max-w-md w-full"
            style={{ backgroundColor: theme?.colors?.secondary || '#374151' }}
          >
            <div className="mb-4" style={{ color: theme.colors.status.error }}>
              <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.98-.833-2.75 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 
              className="text-xl font-bold mb-2 text-center"
              style={{ color: theme.colors.text.primary }}
            >
              Something went wrong
            </h2>
            <p 
              className="mb-4 text-center"
              style={{ color: theme.colors.text.secondary }}
            >
              We encountered an unexpected error. Please refresh the page or try again later.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="w-full px-4 py-2 rounded transition-colors"
              style={{ 
                backgroundColor: theme.colors.accent.primary,
                color: theme.colors.background.primary 
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = theme.colors.accent.secondary}
              onMouseOut={(e) => e.target.style.backgroundColor = theme.colors.accent.primary}
            >
              Refresh Page
            </button>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="mt-4">
                <summary 
                  className="cursor-pointer text-sm"
                  style={{ color: theme.colors.text.secondary }}
                >
                  Error Details (Dev Only)
                </summary>
                <pre 
                  className="text-xs mt-2 p-2 rounded overflow-auto"
                  style={{ 
                    backgroundColor: theme.colors.primary,
                    color: theme.colors.text.secondary 
                  }}
                >
                  {this.state.error.toString()}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;